export enum StepActionType{
  IF_CONDITION = "IF_CONDITION",
  WHILE_LOOP = "WHILE_LOOP",

  FOR_LOOP = "FOR_LOOP"


}
